import { Notification } from 'model';
import { BaseApi } from './BaseAPI';

export const baseURL = 'notifications/';

const NotificationApi = BaseApi.injectEndpoints({
	endpoints: builder => ({
		getNotifications: builder.query<Notification[], void>({
			query: () => ({
				url: `${baseURL}`
			}),
			providesTags: (result, error) => {
				if (error || result === undefined) {
					return [];
				}
				return result.map(({ _id }) => ({ type: 'Notification', id: _id }));
			}
		})
	})
});

export const { useGetNotificationsQuery } = NotificationApi;
